<template>
  <div class="footer">
    <div class="cooper-con">
      <ul class="com-link">
        <li>联系我们</li>
        <li>商务合作：181-5113-1612 (李经理)</li>
        <li>联系地址：江苏省苏州市张家港市物润船联大厦</li>
      </ul>
      <ul class="com-ewm">
        <li><img src="../assets/homePage/wurun-ewm.png" /><span>官方微信公众号</span></li>
        <!-- <li><img src="../assets/homePage/wurun-ewm.png" /><span>官方客户微信</span></li> -->
      </ul>
    </div>
    <div class="foot">
      <span class="copy-right"
        >Copyright ©2011-2021 www.ship56.net All Rights Reserved.</span
      >
      <span class="bei-an">
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32058202010569"
          target="_blank"
        >
          <img src="http://static.ship56.net/img/ghs.png" />
        </a>
      </span>
      <span>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
          苏公网安备 32058202010569号
        </a>
      </span>
      <span class="promise-card">增值电信业务经营许可证苏B2-20140002　
        <a href="http://www.beian.miit.gov.cn" target="_blank">苏ICP备12023245号-1</a>
      </span>
      <span id="master-unit">江苏物润船联网络股份有限公司版权所有</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.footer {
  width: 100%;
  background: #202120;
}

.cooper-con {
  width: 1200px;
  margin: 0 auto;
  height: 150px;
  padding: 36px 0 23px 0;
  border-bottom: 1px solid #515050;
}

.cooper-con {
  background: #202120;
  display: flex;
}

.cooper-con ul.com-link {
  flex: 1;
  text-align: left;
}
.cooper-con ul.com-link li {
  color: #aca9a9;
  line-height: 40px;
}

.cooper-con ul.com-ewm {
  flex: 1;
}

.cooper-con ul.com-ewm li {
  float: right;
  padding: 0 50px;
  text-align: center;
}

.cooper-con ul.com-ewm li img {
  width: 102px;
  height: 102px;
  padding: 0 0 12px 0;
}

.cooper-con ul.com-ewm li span {
  display: block;
  font-size: 15px;
  color: #666;
  line-height: 18px;
}
.cooper-con ul.com-ewm::after {
  display: block;
  content: "";
  clear: both;
}
.foot {
  height: 60px;
  display: block;
  line-height: 60px;
  margin: 0 auto;
  text-align: center;
}

.foot span {
  font-size: 12px;
  color: #666;
  text-align: center;
  padding: 0 26px 0 0;
}

.foot span a {
  color: #666;
}

.foot span.bei-an {
  padding: 0;
}
</style>
